import React from 'react';
import Helmet from 'react-helmet';
import HtmlParser from 'html-react-parser';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { PATHS } from '../../utils/urls';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="press" ontouchstart>
            <SEO title="Press | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Read the latest news about ChartHop. Keep up to date with new company announcements, product releases and more."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Press | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Read the latest news about ChartHop. Keep up to date with new company announcements, product releases and more." />
                <meta property="og:image" content={`https://www.charthop.com/home/press-meta.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Press | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Read the latest news about ChartHop. Keep up to date with new company announcements, product releases and more." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/press-meta.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HERO CONTENT */}
            <section className="hero-centerSectionSpacing">
                <section className="d-flex flex-column contentBlock">
                    <div>
                        <h1 className="text-center">Press</h1>
                        <p className="text-center header-p mb-0">We're building the best people software on the planet.</p>
                        <p className="text-center header-p mb-0">And that's news.</p>
                    </div>
                </section>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing pb-0 flex-centeredColumn">
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">
                    {/* TECHCRUNCH */}
                    <div className="fullWidthCard">
                        <div className="logoContent">
                            <div>
                                <img src={'/press/techcrunch-logo.svg'} alt="Techcrunch" class="logo-techcrunch" />
                            </div>
                        </div>
                        <div className="testimonialContent">
                            <p>“ChartHop, a startup that aims to modernize and automate the organizational chart, announced a $5 million seed investment today led by Andreessen Horowitz.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/press/ron-miller.png'} alt="Ron Miller" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Ron Miller</b></p>
                                    <p className="mb-0">Read more on <a href="https://techcrunch.com/2020/02/20/charthop-grabs-5m-seed-led-by-a16z-to-automate-the-org-chart/" className="ctaStandard" rel="noopener noreferrer" target="_blank">Techcrunch</a></p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    {/* WSJ */}
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src='/press/axios-logo.svg' alt="Axios" class="axios"/>
                            </div>
                        </div>
                    </div>
                    {/* PROTOCOL */}
                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">"ChartHop is building a better internal tool for companies to use to easily visualize their company's org structure and plan their future growth...Beyond making a fancier org chart, it helps companies analyze things like gender and pay equity and also model future open positions.”</p>
                        </div>
                        
                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/press/biz-carson.png'} alt="Biz Carson" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Biz Carson</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.protocol.com/org-chart-startup-linkedin" className="ctaStandard">Protocol</a></p>
                                </div>
                            </div>
                            
                            <div>
                                <img src={'/press/protocol-logo.svg'} alt="Protocol" />
                            </div>
                        </div>
                    </div>
                    {/* A16Z */}

                    <div className="fullWidthCard-imbalanced">
                        <div className="testimonialContent">
                            <p>“ChartHop is the kind of HR software a deeply technical engineering leader would build if they were sick of dealing with spreadsheets to manage hundreds of engineers.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/supporters/david-ulevitch.png'} alt="David Ulevitch" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>David Ulevitch</b></p>
                                    <p className="mb-0">Read more on the <a href="https://a16z.com/2020/02/20/investing-in-charthop/" className="ctaStandard"> a16z blog</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="logoContent sectionSpacing">
                            <div>
                                <img src={'/press/andreessen-horowitz.svg'} alt="a16z" class="andreessen"/>
                            </div>
                        </div>
                    </div>
                    {/* FORTUNE */}
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src={'/press/fortune-logo.svg'} alt="Fortune" />
                            </div>
                        </div>
                    </div>
                    {/* SHRM */}
                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">“With uncertainty around purchasing decisions in the coming 12 to 18 months, employers need to understand the current state of their organization and create multiple headcount hiring scenarios for the future."</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/press/roy-maurer.png'} alt="Roy Maurer" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Roy Maurer</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.shrm.org/ResourcesAndTools/hr-topics/talent-acquisition/Pages/Tips-and-Tools-Engage-Your-Remote-Workers.aspx" className="ctaStandard">SHRM</a></p>
                                </div>
                            </div>
                            <div>
                                <img src={'/press/shrm.svg'} alt="SHRM" />
                            </div>
                        </div>
                    </div>

                    </div>  
            </section>

            {/* PODCAST */}
            <section className="sectionSpacing pb-0 flex-centeredColumn podcast">                
                <h2 className="text-center centerSpacing">Podcast & Videos</h2>
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">
                    <div className="verticalThird mb-0">
                        <a href="https://podcasts.apple.com/us/podcast/forward-thinking-founders/id1454168902" target="_blank">
                            <div class="podcast-item">
                                <div class="icon">
                                    <img src={'/press/play.svg'} alt="Play icon"/>
                                </div>
                                <div class="forward-thinking-founders"></div>
                            </div>
                        </a>
                        <div class="podcast-text">
                            <h2>Forward Thinking Founders</h2>
                            <p>"We’re pioneering a new category that empowers leaders to truly understand their organizations past and current state, and gives them the context they need to plan for their future. </p>        
                            <p>HR leaders are demanding tools that give them the insights and analytics to be strategic + solve a lot of the manual workflows they still have to."</p>                
                        </div>                         
                        <div className="podcast-link">
                            <img src={'/press/mat-sherman.png'} alt="Mat Sherman" />
                            <div className="d-flex flex-column">
                                <p className="my-0"><b>Mat Sherman</b></p>
                                <p className="mb-0">Listen on <a href="https://podcasts.apple.com/us/podcast/forward-thinking-founders/id1454168902" className="ctaStandard"  target="_blank">Forward Thinking Founders</a></p>
                            </div>
                        </div>                       
                    </div>
                    <div className="verticalThird mb-0">
                        <a href="http://techblogwriter.libsyn.com/chart-hop" target="_blank">
                            <div class="podcast-item">
                                <div class="icon">
                                    <img src={'/press/play.svg'} alt="Play icon"/>
                                </div>
                                <div class="tech-talks-daily"></div>
                            </div>
                        </a>
                        <div class="podcast-text">
                            <h2>ChartHop, The Tech Helping Businesses Run and Scale Better</h2>
                            <p>“Getting in the habit of doing planning continuously as business changes is a huge competitive advantage </p> <p> ChartHop takes the overhead out of the planning and the approval processes that exist today and helps organizations be more nimble and intentional in their growth. ”</p>
                        </div>
                        <div className="podcast-link">
                            <img src={'/press/neil-hughes.png'} alt="Neil Hughes" />
                            <div className="d-flex flex-column">
                                <p className="my-0"><b>Neil C. Hughes</b></p>
                                <p className="mb-0">Listen on <a href="http://techblogwriter.libsyn.com/chart-hop" className="ctaStandard"  target="_blank">The Tech Talks Daily</a></p>
                            </div>
                        </div>                
                    </div>
                    <div className="verticalThird mb-0">
                        <a href="https://www.youtube.com/watch?v=GAnanqIb9CE" target="_blank">
                            <div class="podcast-item">
                                <div class="icon">
                                    <img src={'/press/play.svg'} alt="Play icon"/>
                                </div>
                                <div class="a16z"></div>
                            </div>
                        </a>
                        <div class="podcast-text">
                            <h2>We Don't All Need to Learn to Code</h2>
                            <p>"You’re all familiar with the pains of the annual planning process and the dreaded spreadsheets
                            that don't have answers to the questions you really have. 
                            </p> <p>ChartHop can answer the questions that organizations that are trying to be more thoughtful and intentional in their planning and their growth are asking"</p>
                        </div>
                        <div className="podcast-link">
                            <img src={'/press/david-ulevitch.png'} alt="David Ulevitch" />
                            <div className="d-flex flex-column">
                                <p className="my-0"><b>David Ulevitch</b></p>
                                <p className="mb-0">Watch on <a href="https://www.youtube.com/watch?v=GAnanqIb9CE" className="ctaStandard"  target="_blank" >a16z</a></p>
                            </div>
                        </div>                                                
                    </div>
                    
                    
                </div>
                <div className="sectionSpacing"> </div>
            </section>

            {/* HERO CONTENT */}
			<section className="backgroundGradientContainer-Reverse sectionSpacing text-center">
				<div className="flex-centeredColumn">
                <p className="text-center mb-0"> For media inquiries contact <a href="mailto:marketing@charthop.com"  rel="noopener noreferrer" target="_blank">marketing@charthop.com</a>.</p>
                    <p className="text-center my-2">Download official ChartHop logos, platform shots, and team photos.</p>
				</div>

				<div className="flex-centeredColumn">
				<a href={PATHS.MEDIA} rel="noopener noreferrer" target="_blank" className="button primary ">MEDIA KIT</a>
				</div>
             </section>   

            {/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"company-press-demo-bottom"} headertext={HtmlParser("<h2>See what everyone is talking about. </br>  </br> Get in touch!</h2>")}/>
            </section>
        </Layout>
    );
};


export default Home;
